import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const redirectState = queryParams.get("view_profile");
  console.log("PublicRoute:::", redirectState);
  const token = localStorage.getItem("authToken");
  if (redirectState === "false" && token) {
    return <Navigate to="/emailListing" replace />;
  } else if (redirectState === "true" && token) {
    return <Navigate to="/profile" replace />;
  } else {
    // If user is logged in, redirect them to home
    return token ? <Navigate to="/dashboard" replace /> : <Outlet />;
  }
};

export default PublicRoute;
